import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

// import { SearchCustomerComponent } from '../search-customer/search-customer.component';
// import { KeyboardComponent } from '../keyboard/keyboard.component';
// import { InvoiceItemComponent } from '../invoice-item/invoice-item.component';

@Component({
  selector: 'app-qutation',
  templateUrl: './qutation.component.html',
  styleUrls: ['./qutation.component.css']
})
export class QutationComponent implements OnInit {

  public menu_item_id = '13';
  public add_auth;

  // search_obj = {
  //   'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`customer`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile']
  //   }]
  // };

  model = {
    'table_name': 'qutation', 'qutation_id': '0', 'qutation_no': '', 'no': '0', 'year': '', 'qutation_date': '0000-00-00', 
    'expiry_date': '0000-00-00', 'customer_no': '', 'customer_name': '', 'calc_tax': '1', 'print_tax': '1', 
    'total': '', 'tax': '', 'discount': '', 'invoice_type': 'qutation', 'cond_list_id': '0', 
    'po_no': '', 'for_install_invoice': '0', 'advanced_perc': '0', 'flag': '', 'key': 'qutation_id',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'comment': ''
  };

  data_model = { 'type': 'qutation', 'qutationDate': new Date(), 'expiryDate': new Date(), 'final_total': '' };

  search_obj = {
    'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'condition': " AND `branch_id` = '" + this.model['branch_id'] + "'"
    }]
  };

  // searchDialogRef: MatDialogRef<SearchCustomerComponent>;

  qutation_no = '';
  type = '';
  print_type;
  invCondList = [];
  dp = [];
  public toDelete = [];

  customerDetail = '';
  saveClicked = false;

  Customer_Placeholder; Success_Msg; Error_Msg; One_Item_Msg; Qutation_No;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, private queryList: QueryList, 
    public dialog: MatDialog, private router: Router, public translate: TranslateService, private route: ActivatedRoute) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Customer_Placeholder').subscribe((res: string) => {
      this.Customer_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Customer_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('One_Item_Msg').subscribe((res: string) => {
      this.One_Item_Msg = res;
    });

    translate.get('Qutation_No').subscribe((res: string) => {
      this.Qutation_No = res;
    });
  }

  ngOnInit() {

    // check add authorization
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    let query, obj;

    this.model['calc_tax'] = this.utils.getParamValue('cal_tax');
    (document.getElementById('for_install_invoice') as HTMLInputElement).checked = (this.model['for_install_invoice'] == '1');

    this.print_type = this.utils.getParamValue('print_type');
    let condition = (this.print_type == 'normal' ? "`def_cond_list_id` = '1'" : "`def_cond_list_id` = '2'");

    query = "SELECT `cond_list_id` FROM `def_inv_cond_list` WHERE " + condition;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.data['list'].length > 0)
          this.model['cond_list_id'] = data.data['list'][0]['cond_list_id'];
      });

    query = this.queryList.all_invCondList;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.invCondList = data.data['list'];
        this.invCondList.unshift({ 'cond_list_id': '0', 'list_name': 'اختر', 'list_name_en': 'Select' });
      });


    this.route.params.subscribe(params => {

      if (params['no'] != undefined) {
        this.qutation_no = params['no'];
        this.model['qutation_no'] = this.qutation_no;

        if (params['type'] != undefined)
          this.type = params['type'];

        // obj = { cmd: 'getInvoiceDetail', type: 'qutation', no: this.model['qutation_no'] };
        query = "SELECT `qutation`.* FROM `qutation` WHERE `qutation`.`qutation_no` = '" + this.qutation_no + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let qutation_detail = data.data['list'][0];
            this.model = {
              'table_name': 'qutation', 'qutation_id': qutation_detail['qutation_id'], 'qutation_no': this.qutation_no, 
              'no': qutation_detail['no'], 'year': qutation_detail['year'], 'qutation_date': qutation_detail['qutation_date'], 
              'expiry_date': qutation_detail['expiry_date'], 'customer_no': qutation_detail['customer_no'], 
              'customer_name': qutation_detail['customer_name'], 'calc_tax': qutation_detail['calc_tax'], 
              'print_tax': qutation_detail['print_tax'], 'total': qutation_detail['total'], 'tax': qutation_detail['tax'], 
              'discount': qutation_detail['discount'], 'invoice_type': qutation_detail['invoice_type'], 
              'cond_list_id': qutation_detail['cond_list_id'], 'po_no': qutation_detail['po_no'], 
              'for_install_invoice': qutation_detail['for_install_invoice'], 'advanced_perc': qutation_detail['advanced_perc'],
              'flag': (this.type == 'copy' ? '' : 'update'), 'key': 'qutation_id', 'branch_id': qutation_detail['branch_id'], 'comment': qutation_detail['comment']
            };

            this.data_model['qutationDate'] = new Date(this.model['qutation_date']);
            this.data_model['expiryDate'] = new Date(this.model['expiry_date']);

            this.data_model['final_total'] = (Number(this.model['total']) - Number(this.model['discount']) + 
              Number(this.model['tax'])).toFixed(2);

            if (this.model['customer_no'] == '')
              this.customerDetail = this.model['customer_name'];
            else {
              query = "SELECT * FROM `customer` WHERE `acct_number` = '" + this.model['customer_no'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  let custDetail = data.data['list'][0];
                  this.customerDetail = custDetail['acct_number'] + "-" + custDetail['customer_name'] +
                    "-" + custDetail['customer_name_en'] + "-" + custDetail['mobile'];
                });
            }

            // get qutation item list
            obj = { cmd: 'getInvoiceItem', type: 'qutation', invoice_no: this.qutation_no };
            this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success')
                  this.dp = data.status['msg'];
              });
            
          });
      }
    });
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.model['customer_name'] = search_result['value'];
    this.model['customer_no'] = search_result['no'];
  }

  onChange = function (dpList: any) {
    this.dp = dpList['dp'];
  }

  // changeInstall() {
  //   this.model['for_install_invoice'] = ((document.getElementById('for_install_invoice') as HTMLInputElement).checked ? '1' : '0');
  // }

  saveQutation(save_type) {
    this.saveClicked = true;
    // this.router.navigate(['sub_menu/1/qutation']);

    // if(this.data_model['has_customer'] == '1' && this.model['customer_no'] == '')
    //   alert("الرجاء اختيار العميل في حال اختيار البحث عن العميل");
    // else 
    if (this.model['total'] == '' || Number(this.model['total']) == 0) {
      alert(this.One_Item_Msg);
      this.saveClicked = false;
      return;
    }

    let year = this.data_model['qutationDate'].getFullYear();

    this.model['qutation_date'] = this.data_model['qutationDate'].getFullYear() + "-" +
      (this.data_model['qutationDate'].getMonth() + 1) + "-" + this.data_model['qutationDate'].getDate() + " " +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds();

    this.model['expiry_date'] = this.data_model['expiryDate'].getFullYear() + "-" +
      (this.data_model['expiryDate'].getMonth() + 1) + "-" + this.data_model['expiryDate'].getDate() + " " +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds();

    if (this.type == 'copy') {
      this.model['qutation_id'] = '0';
      this.model['qutation_no'] = '';
    }

    let values = [];
    values.push(this.model);

    this.dp.forEach(element => {

      if (element.sub_item_number != '' || (element.sub_item_name != '' && element.total_price != '')) {

        values.push({
          'table_name': 'qutation_item', 'qutation_item_id': (this.type == '' ? element.qutation_item_id : '0'), 
          'qutation_no': this.model['qutation_no'], 'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name, 
          'count': element.count, 'price': element.price, 'unit_id': element.unit_id, 'total_price': element.total_price, 
          'tax_no': element.tax_no, 'tax_amount': element.tax_amount, 'discount': element.discount, 
          'flag': (this.type == '' ? element.flag : ''), 'key': element.key, 'comment': element.comment
        });
      }
    });

    if (this.type == '') {
      this.toDelete.forEach(delElem => {
        values.push({
          'table_name': delElem['table_name'], 'qutation_item_id': delElem.qutation_item_id,
          'key': 'qutation_item_id', 'flag': 'delete', 'qutation_no': this.model['qutation_no']
        });
      });
    }

    let obj;
    if (this.model['qutation_id'] == '0') {
      this.model['year'] = String(year);

      let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
      this.applicationConstants.user_branch_info.user_branch_id + "'";
      let prefix = this.applicationConstants.user_branch_info.user_branch_id + '-' + year + '-';

      obj = {
        cmd: 'add', values: values, pk: 'qutation_no', id: 'no', main_table: 'qutation',
        prefix: prefix, idWhere: idWhere
      };
    }
    else
      obj = { cmd: 'updateAdv', values: values };
    
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {

          if (this.model['qutation_id'] == '0')
            this.model['qutation_no'] = data.status['msg'][0]['number'];
           
          alert(this.Success_Msg + ", " + this.Qutation_No + ": " + this.model['qutation_no']);

          if (save_type == 'print')
            window.open(this.applicationConstants.generatePDF + "?type=qutation&no=" + this.model['qutation_no'], "_blank");

          this.router.navigate(['sub_menu/1/qutation_list']);
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });

  }

}
